import { getRoleDisplayName, roleColors, type UserRole } from '../../utils/roleColors';
import { 
  Shield, 
  Scale, 
  User, 
  Gavel, 
  Settings 
} from 'lucide-react';

interface RoleBadgeProps {
  role: UserRole;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  className?: string;
  department?: string;
}

const roleLabels: Record<UserRole, string> = {
  LawEnforcement: 'Law Enforcement',
  Attorney: 'Attorney',
  PublicSubmitter: 'Public',
  CaseManager: 'Case Manager',
  SystemAdmin: 'Admin',
  Judge: 'Judge',
};

const roleIcons: Record<UserRole, typeof Shield> = {
  LawEnforcement: Shield,
  Attorney: Scale,
  PublicSubmitter: User,
  CaseManager: Gavel,
  SystemAdmin: Settings,
  Judge: Gavel,
};

const sizeClasses = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
};

const iconSizes = {
  sm: 'h-3 w-3',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
};

export function RoleBadge({ 
  role, 
  size = 'md', 
  showIcon = false,
  className = '',
  department,
}: RoleBadgeProps) {
  const colors = roleColors[role];
  const Icon = roleIcons[role];
  const label = role === 'Attorney'
    ? getRoleDisplayName(role, department)
    : roleLabels[role];

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-medium rounded-full ${colors.badge} ${sizeClasses[size]} ${className}`}
    >
      {showIcon && <Icon className={iconSizes[size]} />}
      {label}
    </span>
  );
}

export default RoleBadge;
